import React, { FC } from 'react';

import './footer.css';

import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import footerLogoIcon from '../../images/CompanyLogo.png';
import { useGlobalState } from '../../Providers';

const Footer: FC<{ className?: string }> = ({ className }) => {
    const { translate } = useLocale();
    const env =  import.meta.env.VITE_BRAND_PATH;
    const {buildInfo} = useGlobalState() ?? {};

    return (
        <footer className={`box-border footer text-sm bg-white flex flex-row justify-between items-center ${className}`}>
            <button className='pl-6 aboutUsLink' onClick={() => window.open(buildInfo?.companyWebsite)} >{translate.byKey(TranslationKeys.aboutUs)}</button>
            <div>{translate.byKey(TranslationKeys.termsAndConditions)}</div>

            <div className="footer-logo">
                <img src={footerLogoIcon} alt="company logo"
                    className="h-16" />
            </div>

            <div className="footer-copyright"></div>
            <div />
        </footer>
    );
};

export default Footer;
